export enum SortOrder {
  Asc = "asc",
  Desc = "desc",
}
export interface SortOptions {
  readonly [column: string]: SortOrder;
}

export interface QueryOptions {
  readonly order_by?: Array<SortOptions>;
  readonly results_per_page?: number;
  readonly page_number?: number;
}

export interface ProcedureCodeListOptions extends QueryOptions {
  readonly codes?: Array<string>;
  readonly code?: string;
}

interface ProcedureCode {
    id: number;
    code: string;
    short_description: string;
    long_description: string;
  }

export interface ProcedureCodeListResponse {
  readonly results: ReadonlyArray<ProcedureCodeResult>;
  readonly result_count: string;
}

export interface ProcedureCodeResult {
    procedure_code: ProcedureCode;
  }
